module.exports = __webpack_public_path__ + "static/media/history.4848df15.svg";